import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  conditionNotes: {
    textAlign: "end",
    fontStyle: "italic"
  }
});
